module.exports = __webpack_public_path__ + "img/fudgy_brownie.c8f4f820.jpg";